import React from "react";
import { useNobodySausageGlyph } from "../contexts/NobodySausageGlyphContext";
import { logger } from "../utils/logger";

interface NobodySausageGlyphConnectButtonProps {
  onConnect?: () => void;
}

function isUserRejection(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : String(error ?? "");
  return /user rejected|user denied|rejected the request|closed/i.test(message);
}

export function NobodySausageGlyphConnectButton({
  onConnect,
}: NobodySausageGlyphConnectButtonProps) {
  const { connect, isConnecting } = useNobodySausageGlyph();

  const handleConnect = async () => {
    try {
      await connect();
      onConnect?.();
    } catch (error) {
      // User closing/rejecting the Glyph popup is an expected outcome, not a crash.
      if (isUserRejection(error)) {
        logger.wallet("Glyph connection cancelled by user");
        return;
      }
      logger.walletError("Glyph connection failed", error as Error);
    }
  };

  return (
    <button
      onClick={() => {
        void handleConnect();
      }}
      style={{
        backgroundColor: "transparent",
        color: "black",
        border: "2px solid black",
        padding: "8px 16px",
        fontSize: "15px",
        fontWeight: "bold",
        fontFamily: "inherit",
        lineHeight: "1",
        borderRadius: "0px",
        width: "100%",
        minHeight: "35px",
      }}
      disabled={isConnecting}
    >
      {isConnecting ? "Connecting Glyph..." : "Connect Glyph wallet"}
    </button>
  );
}
